import {Utilities} from '@learningblocks/exp-constants';
const {checkIfSelectionValid} = Utilities;

// set a question checkbox as selected
export function selectCheckboxOption(state, payload) {
  return {
    ...state,
    currentChapter: updateCheckboxInCurrentChapter(
      state.currentChapter,
      payload
    ),
  };
}

function updateCheckboxInCurrentChapter(currentChapter, payload) {
  return {
    ...currentChapter,
    components: updateCheckboxInComponents(currentChapter.components, payload),
  };
}

function updateCheckboxInComponents(components, payload) {
  const updateComponent = (component) => {
    if (component.id === payload.componentID) {
      component = updateCheckboxInMSCQComponent(component, payload);
    }
    return component;
  };
  return components.map(updateComponent);
}

function updateCheckboxInMSCQComponent(component, payload) {
  const updateOptionCheckbox = (checkboxOption) => {
    if (checkboxOption.disabled === false) {
      if (payload.optionID === checkboxOption.id) {
        checkboxOption.selected = payload.checked;
      }
    } else {
      // removing selected from all disabled options.
      // to gray out invalid options by incorrect.
      checkboxOption.selected = false;
    }
    return {...checkboxOption};
  };

  if (checkIfSelectionValid(component)) {
    component.checkboxes = component.checkboxes.map(updateOptionCheckbox);
  }
  return component;
}
